import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ProfileSettingsComponent } from "./profile-settings/profile-settings.component";
import { AuthGuard } from "../services/auth-gaurd.service";
import { CountryBlockedComponent } from "./country-blocked/country-blocked.component";
import { TransactionComponent } from "./transaction/transaction.component";
import { BetHistoryComponent } from "./bet-history/bet-history.component";
import { CompleteProfileComponent } from "./complete-profile/complete-profile.component";
const routes: Routes = [
    {
        path: '',
        component: ProfileSettingsComponent,
        canActivateChild: [AuthGuard],
        children: [
          {
            path: '', component: CompleteProfileComponent
          },
          {
            path: 'transactions', component: TransactionComponent
          },
          {
            path: 'bethistory', component: BetHistoryComponent
          },
          {
            path: 'countryblocked', component: CountryBlockedComponent
          }
        ]
      },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MyAccountRoutingModule{}